/**
 * MODULE: domain/pages/frontend/utils/pageDealRoomUtils.ts
 * PURPOSE: Formatting helpers for deal room banner and stage labels
 */

export function formatDealStageLabel(stage: string): string {
  return stage
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function formatDealAmount(
  amount: number | null | undefined,
  currency = 'GBP',
): string | null {
  if (amount == null || Number.isNaN(amount)) return null;
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}
